import { getSaltOnSearch } from "../../../PharmacyMedicineAdd/PharmacyMedicineService";

export const searchMedicineResearch = (searchKeyword, isOTC) =>
	getSaltOnSearch({
		search: searchKeyword,
		type: isOTC ? "otc" : "",
	});
